import Vue from 'vue';

export default [
    {
        pathId: 'ccs',
        component: 'components',
        title: 'Course Components',
        icon: 'fa-cubes',
        size: 'sm',
        loading: true
    }, {
        pathId: 'cc',
        component: 'component-editor',
        title: 'Editor',
        icon: 'fa-edit',
        size: 'xl',
        props: ['componentId'],
        loading: true
    },  {
        pathId: 'new-cc',
        component: 'new-component-editor',
        title: 'Editor',
        icon: 'fa-edit',
        size: 'xl',
        props: ['componentId', 'outlineId'],
        loading: true
    }, {
        pathId: 'ccn',
        component: 'new-component',
        title: 'New Component',
        icon: 'fa-plus',
        size: 'sm'
    }, {
        pathId: 'cce',
        component: 'edit-component',
        title: 'Edit Component',
        icon: 'fa-pencil',
        size: 'sm',
        props: ['componentId'],
        loading: true
    }
];

Vue.component('components', () => import('@/cards/components/Components'));
Vue.component('component-editor', () => import('@/cards/components/Editor'));
Vue.component('new-component-editor', () => import('@/cards/components/NewEditor'));
Vue.component('new-component', () => import('@/cards/components/NewComponent'));
Vue.component('edit-component', () => import('@/cards/components/EditComponent'));
